import React, { useState, useEffect } from 'react';
import { useNavigation } from 'context/NavigationContext';
import {
	BringzzPageContainer,
	BringzzButton,
	BringzzIcon,
	BringzzText
} from '@bringzz/components';
import { toast } from 'react-toastify';
import useRequest from 'hooks/useRequest';
import { useTranslation } from 'react-i18next';

const EditPharmacyNightDuties = () => {
	const { t } = useTranslation();
	const { backPress, navigate } = useNavigation();
	const { sendRequest, loading } = useRequest();
	const [firstDate, setFirstDate] = useState('');
	const [secondDate, setSecondDate] = useState('');
	const [thirdDate, setThirdDate] = useState('');
	const [interval, setInterval] = useState(5);

	useEffect(() => {
		const fetchNightDutySchedule = async () => {
			try {
				const response = await sendRequest({
					method: 'GET',
					url: '/module/pharmacyopening/getNightDutySchedule',
				});
				if (response.status === 'success') {
					const { next_night_duty, following_night_duty, subsequent_night_duty, interval } = response.data;

					setFirstDate(next_night_duty.split(' ')[0]);
					setSecondDate(following_night_duty.split(' ')[0]);
					setThirdDate(subsequent_night_duty.split(' ')[0]);
					setInterval(interval);
				}
			} catch (error) {
				console.error("Error fetching night duty schedule", error);
			}
		};

		fetchNightDutySchedule();
	}, [sendRequest]);

	const saveSchedule = async () => {
		const requestData = {
			next_night_duty: firstDate,
			following_night_duty: secondDate,
			subsequent_night_duty: thirdDate,
		};

		try {
			const response = await sendRequest({
				method: 'POST',
				url: '/module/pharmacyopening/updateNightDutySchedule',
				data: requestData,
			});

			if (response.status === 'success') {
				toast.success(t('component.night_duties.toast.update_success'));
				navigate(`/settings/pharmacy/info`, false);
			} else {
				toast.error(t('component.night_duties.toast.update_failed'));
			}
		} catch (error) {
			console.error("Error saving night duty schedule", error);
			toast.error(t('component.night_duties.toast.save_error'));
		}
	};

	return (
		<BringzzPageContainer
			header={{
				left: (
					<BringzzIcon
						size="22"
						icon="IconChevronLeft"
						folder="LineIcons"
						className="cursor-pointer"
						onClick={backPress}
					/>
				),
				title: <BringzzText tag="h2">{t('component.night_duties.title')}</BringzzText>
			}}
			footer={
				<div className="pb-28 px-6">
					<BringzzButton
						size="lg"
						className="bg-magic-lilac w-full flex justify-center text-midnight-blue"
						onClick={saveSchedule}
						disabled={loading}
					>
						{t('component.night_duties.save')}
					</BringzzButton>
				</div>
			}
		>
			<div className="p-6 space-y-4">
				<div className="space-y-4">
					<label className="block text-sm font-semibold text-midnight-blue">
						{t('component.night_duties.next_night_duty')}
					</label>
					<input
						type="date"
						className="w-full border rounded-md p-2 cursor-pointer"
						value={firstDate}
						onChange={e => setFirstDate(e.target.value)}
						max={secondDate}
						onClick={e => e.target.showPicker?.()}
					/>
				</div>

				<div className="space-y-4">
					<label className="block text-sm font-semibold text-midnight-blue">
						{t('component.night_duties.night_duty_after')}
					</label>
					<input
						type="date"
						className="w-full border rounded-md p-2 cursor-pointer"
						value={secondDate}
						onChange={e => setSecondDate(e.target.value)}
						min={firstDate}
						max={thirdDate}
						onClick={e => e.target.showPicker?.()}
					/>
				</div>

				<div className="space-y-4">
					<label className="block text-sm font-semibold text-midnight-blue">
						{t('component.night_duties.night_duty_after')}
					</label>
					<input
						type="date"
						className="w-full border rounded-md p-2 cursor-pointer"
						value={thirdDate}
						onChange={e => setThirdDate(e.target.value)}
						min={secondDate}
						onClick={e => e.target.showPicker?.()}
					/>
				</div>

				<div className="p-4 border rounded-md mt-8">
					<BringzzText tag="h4" className="font-regular text-midnight-blue/40">
						{t('component.night_duties.night_duty_interval')} <span className="font-bold">{interval} {t('component.night_duties.days')}</span>
					</BringzzText>
				</div>
			</div>
		</BringzzPageContainer>
	);
};

export default EditPharmacyNightDuties;
